import styled, { css } from 'styled-components';
import { Gray, White, Blue } from '../../colors';
import { Paragraph } from '../typographies';
import { SimpleTooltipPosition } from './types/simple-tooltip.types';
const leftPosition = css `
  top: 55px;
  bottom: auto;
  right: 128%;
`;
const rightPosition = css `
  top: 55px;
  left: 125%;
`;
const upPosition = css `
  top: -50%;
  left: -75%;
`;
const downPosition = css `
  top: 430%;
  left: -75%;
`;
const insidePosition = css `
  top: 80%;
  right: 70%;
  padding: 5px 22px 8px 11px;
  clip-path: polygon(0 0, 0 100%, 87% 100%, 87% 30%, 100% 0);
`;
const selectDirection = (position) => (position === SimpleTooltipPosition.UP && upPosition) ||
    (position === SimpleTooltipPosition.DOWN && downPosition) ||
    (position === SimpleTooltipPosition.LEFT && leftPosition) ||
    (position === SimpleTooltipPosition.RIGHT && rightPosition) ||
    (position === SimpleTooltipPosition.INSIDE && insidePosition);
export const TooltipBox = styled.div `

  opacity: 0;
  visibility: hidden;
  position: absolute;
  display: flex;
  z-index: 2000;
  transition: 0.3s;
  border-radius: 4px;
  padding: 14px 20px;
  transform: translateY(-105%);
  border: 1px solid ${Gray.light};
  background-color: ${White.normal};
  width: max-content;
  max-width: ${({ maxWidth }) => maxWidth ? `${maxWidth}px ` : '300px'};

  box-shadow: -1px 9px 16px -2px rgba(0,0,0,0.21);
  -moz-box-shadow: -1px 9px 16px -2px rgba(0,0,0,0.21);
  -webkit-box-shadow: -1px 9px 16px -2px rgba(0,0,0,0.21);

  ${({ position }) => selectDirection(position)}
`;
export const SimpleTooltipContainer = styled.div `
  position: relative;
  display: inline-block;

  &:hover ${TooltipBox} {
    visibility: visible;
    opacity: 1;
  }
`;
export const TooltipText = styled(Paragraph) `
  margin: 0;
  color: ${Blue.dark}
`;
//# sourceMappingURL=SimpleTooltip.Styled.js.map